import React, { useState } from 'react';
import { List, Steps } from 'antd';
import Icon from '../../../icon/Icon';
import { type IOffer } from '../../../../store/slices/offersSlice';
import { type Unit } from '../../../../store/slices/unitsSlice';
import renderOfferStatus from '../../../../functions/agent/offers/renderOfferStatus';
import { type TimelineItem } from '../viewingTimelines/ViewingTimeline';
import StepComponent from './StepComponent';
import { textsOfferTimelineRent } from '../../../texts/timelinesTexts';
interface IProps {
    offer: IOffer
    unit: Unit

}



export default function GroupTimelineRent({ offer, unit }: IProps): JSX.Element {
    let process = 0
    const offerStatuses = [renderOfferStatus(offer?.attributes?.Statuses[0], offer.id)]


    if (offerStatuses?.includes('Client docs required')) {
        process = 0
    } if (offerStatuses?.includes('Resubmit required')) {
        process = 0
        textsOfferTimelineRent.stepClientData = 'Resubmit and wait sent offer.'
        textsOfferTimelineRent.descriptionStepClientData = 'Our specialist will be sent your offer soon after you resubmit.'
    }

    const groupDocumentation: TimelineItem[] = [
        {
            title: <StepComponent
                title={textsOfferTimelineRent.stepClientData}
                // description={textsOfferTimelineRent.descriptionStepClientData}
                process={0}
                currentProcess={process}
                statuses={offerStatuses}
                rejectReason={process === 0 ? offer?.attributes?.RejectReason ?? undefined : undefined}
            />,
            status: undefined,
            // description: (<span className='fs-7'>{textsOfferTimelineSale.descriptionStepClientData}</span>)
        }
    ]

    if (offerStatuses?.includes('In-process')) {
        process = 0
    } else if (offerStatuses?.includes("Sent to landlord") || offerStatuses?.includes("Approved")) {
        process = 1
    } else if (offerStatuses?.includes('Negotiated by agent') || offerStatuses?.includes('Negotiated by yourself')) {
        process = 1
        textsOfferTimelineRent.stepInProcess = "Client's documents and additional information added and approved"
        textsOfferTimelineRent.stepApprovedOrRejected = 'You requested the offer negotiation'
        textsOfferTimelineRent.descriptionApprovedOrRejected = 'Please wait until our specialist or the landlord takes action about your negotiation of this offer'
    } else if (offerStatuses?.includes('Negotiated by BSO')) {
        process = 1
        textsOfferTimelineRent.stepInProcess = "Client's documents and additional information added and approved"
        textsOfferTimelineRent.stepApprovedOrRejected = 'The BSO offered another option from landlord'
        textsOfferTimelineRent.descriptionApprovedOrRejected = 'If you are satisfied, wait for a call from BSO, or provide updated offer details.'
    } else if (offerStatuses?.includes('Negotiated by landlord')) {
        process = 1
        textsOfferTimelineRent.stepInProcess = "Client's documents and additional information added and approved"
        textsOfferTimelineRent.stepApprovedOrRejected = 'The landlord offered another option'
        textsOfferTimelineRent.descriptionApprovedOrRejected = 'If you are satisfied, wait call from BSO, or provide updated offer details.'
    } else if (offerStatuses?.includes('Pending BSO admin confirmation')) {
        process = 1
        textsOfferTimelineRent.stepInProcess = "Client's documents and additional information added and approved"
        textsOfferTimelineRent.stepApprovedOrRejected = 'In the process of reviewing your consent.'
        textsOfferTimelineRent.descriptionApprovedOrRejected = 'Please wait until our specialist will be reviewing your consent.'
    }

    const groupUnderReview: TimelineItem[] = [
        {
            title: <StepComponent
                title={textsOfferTimelineRent.stepInProcess}
                process={0}
                currentProcess={process}
                statuses={offerStatuses}
                rejectReason={process === 0 ? offer?.attributes?.RejectReason ?? undefined : undefined}
            />,
            //  description: (<span className='fs-7'>{textsOfferTimelineSale.descriptionInProcess}</span>)
        },
        {
            title: <StepComponent
                title={textsOfferTimelineRent.stepApprovedOrRejected + '\n' + textsOfferTimelineRent.descriptionApprovedOrRejected}
                negotiationReason={process === 1 ? offer?.attributes?.RejectReason ?? undefined : undefined}
                process={1}
                currentProcess={process}
                statuses={offerStatuses}
            />,
            //  description: textsOfferTimelineSale.descriptionApprovedOrRejected
        }
    ]


    if (offerStatuses?.includes('Confirmed')) {
        process = 0
        textsOfferTimelineRent.stepConfirmed = textsOfferTimelineRent.stepPayUploading
        textsOfferTimelineRent.descriptionConfirmed = textsOfferTimelineRent.descriptionPayUploading
    } else if (offerStatuses?.includes('Waiting for slip approval')) {
        process = 1
        textsOfferTimelineRent.descriptionConfirmed = ''
    } else if (offerStatuses?.includes('Slip approved')) {
        process = 2
    } else if (offerStatuses?.includes('Slip rejected')) {
        process = 2
    } else if (offerStatuses?.includes('Waiting booking form send')) {
        process = 3
    } else if (offerStatuses?.includes('Waiting booking form sign')) {
        process = 3
    }

    const groupConfirmationAndFinalization: TimelineItem[] = [
        {
            title: <StepComponent
                title={textsOfferTimelineRent.stepConfirmed + '\n' + textsOfferTimelineRent.descriptionConfirmed}
                process={0}
                currentProcess={process}
                statuses={offerStatuses}
                negotiationReason={process === 0 ? offer?.attributes?.RejectReason ?? undefined : undefined}
            />,
        },
        {
            title: <StepComponent
                title={textsOfferTimelineRent.stepPaySlip}
                // description={textsOfferTimelineRent.descriptionPaySlip}
                process={1}
                currentProcess={process}
                statuses={offerStatuses}
            />,
            //  description: textsOfferTimelineRent.descriptionPaySlip
        },
        {
            title: <StepComponent
                title={textsOfferTimelineRent.stepBFSending}
                // description={textsOfferTimelineRent.descriptionBFSending}
                process={2}
                currentProcess={process}
                statuses={offerStatuses}
            />,
            //  description: textsOfferTimelineRent.descriptionBFSending
        }, {
            title: <StepComponent
                title={textsOfferTimelineRent.stepBFSinging}
                //    description={textsOfferTimelineRent.descriptionBFSinging}
                process={3}
                currentProcess={process}
                statuses={offerStatuses}
            />,
            // description: textsOfferTimelineRent.descriptionBFSinging
        }
    ]




    if (offerStatuses?.includes('Canceled') || offerStatuses?.includes('Canceled by yourself') || offerStatuses?.includes('Canceled by agent')) {
        process = 0
        textsOfferTimelineRent.stepApprovedOrRejected = 'You have canceled Offer!'
    } else if (offerStatuses?.includes('Rejected')) {
        process = 0
        textsOfferTimelineRent.stepApprovedOrRejected = 'Your offer was rejected by BSO.'
        textsOfferTimelineRent.descriptionApprovedOrRejected = 'Unfortunately, our specialist has decided to reject your offer because of the reason stated above'
    } else if (offerStatuses?.includes('Completed')) {
        process = 0
        textsOfferTimelineRent.stepApprovedOrRejected = 'Deal closed successfully.'
    }
    const groupClosure: TimelineItem[] =
        [
            {
                title: <StepComponent
                    title={textsOfferTimelineRent.stepApprovedOrRejected}
                    process={0}
                    currentProcess={process}
                    statuses={offerStatuses}
                    rejectReason={process === 0 ? offer?.attributes?.RejectReason ?? undefined : undefined}
                />,
                status: 'finish',
            }
        ]

    const data = [
        ...(!(offerStatuses[0].includes("Canceled") || offerStatuses[0].includes("Rejected")) ? [
            {
                title: 'Documentation',
                status: undefined,
                current: 0,
                icon: <i className="ki-duotone ki-paper-clip fs-5x"></i>,
                iconProcess: <i className="ki-duotone ki-paper-clip fs-5x text-success"></i>,
                description: 'The stage where client documents are required or need resubmission.',
                statuses: ['Client docs required', 'Resubmit required'], // email + notify
                items: groupDocumentation
            },
            {
                title: 'Under review',
                current: 1,
                status: undefined,
                icon: <i className="ki-duotone ki-loading fs-5x">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>,

                iconProcess: <i className="ki-duotone ki-loading fs-5x text-success">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>,
                description: 'The initial stage where terms are being discussed and adjusted, where the deal is being processed.', // notify
                statuses: ['In-process',
                    "Sent to landlord",
                    "Approved",
                    'Negotiated by other agent', 'Negotiated by agent',
                    'Negotiated by BSO',
                    'Negotiated by landlord',
                    'Pending BSO admin confirmation'
                ],
                items: groupUnderReview
            },
            {
                title: 'Confirmations & Finalization',
                current: 2,
                status: undefined,
                icon: <i className="ki-duotone ki-scroll fs-5x">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                </i>,
                iconProcess: <i className="ki-duotone ki-scroll fs-5x text-success">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                </i>,
                description: 'This stage involves confirming the terms of the deal, agreeing on final conditions, and preparing for the next steps, including payment approvals, form submissions, and other formalities.',
                statuses: [
                    'Confirmed',
                    'Waiting booking form send', 'Waiting booking form sign',
                    'Slip approved', 'Slip rejected', 'Waiting for slip approval'
                ],
                items: groupConfirmationAndFinalization
            }] : []), // notify

        {
            title: 'Closure',
            status: undefined,
            icon: <i className="ki-duotone ki-check fs-5x"></i>,
            iconProcess: <i className="ki-duotone ki-check fs-5x text-success"></i>,
            description: 'The stage where the deal is closed either completed.',
            statuses: ['Completed', 'Rejected', 'Canceled', 'Canceled by BSO', 'Canceled by agent', 'Canceled by yourself', 'Canceled by other agent'], // email + notify
            items: groupClosure
        },
    ];



    const [expanded, setExpanded] = useState(false);

    const activeStepIndex = data.findIndex(step =>
        step.statuses.includes(offerStatuses[0])
        // ||
        // (step.title === 'Conformations & Finalization'
        //     && !step.statuses.includes(offerStatuses[0])
        //     && Boolean(offer?.attributes?.StatusUpdateDescription))
    );

    const renderSteps = (items: any[], currentProcess: number): any => {
        const startIndex = Math.max(0, currentProcess - 1);
        const endIndex = Math.min(items.length, currentProcess + 2);
        const stepsToShow = expanded ? items : items.slice(startIndex, endIndex);
        return stepsToShow.map((item: any, idx: number) => {
            const realIndex = expanded ? idx : startIndex + idx;
            let status: string;
            if (realIndex < currentProcess) {
                status = "finish";
            } else if (realIndex === currentProcess) {
                status = "process";
            } else {
                status = "wait";
            }
            return {
                ...item,
                status,
            };
        });
    };
    return (
        <div className='my-4 pt-2' style={{ maxWidth: '450px', width: '100%' }}>
            <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(group, index) => {
                    const isActive = index === activeStepIndex;
                    const currentProcess = process;
                    return (
                        <div className='d-flex flex-column'>
                            <List.Item >
                                <div className='d-flex flex-column w-100'>
                                    <List.Item.Meta
                                        style={{
                                            lineHeight: 0.1
                                        }}
                                        avatar={
                                            <div className={`d-flex align-items-center justify-content-center w-100`}>
                                                {isActive ?
                                                    offerStatuses[0].includes("Completed") ?
                                                        <span className={'border border-2 align-middle p-7 position-relative border-success  rounded rounded-circle'}>
                                                        </span> : offerStatuses[0].includes("Canceled") || offerStatuses[0].includes("Rejected") ?
                                                            <span className={'border border-2 align-middle p-7 position-relative border-danger  rounded rounded-circle'}>
                                                            </span> :
                                                            < span className={'spinner-border spinner-border-sm align-middle p-7 position-relative text-success'}>
                                                            </span>
                                                    : null}
                                                <span className={`position-${isActive ? 'absolute' : 'static'}`}>
                                                    {isActive ? offerStatuses[0].includes("Canceled") || offerStatuses[0].includes("Rejected") ? <i className="ki-duotone ki-cross-circle fs-5x text-danger">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> : group.iconProcess : group.icon}
                                                </span>
                                            </div>
                                        }
                                        title={<div className='lh-1'><span className='lh-1 fs-4'>{group.title.toUpperCase()}</span></div>}
                                        description={<div className='lh-1'><span className='lh-1 fs-7'>{group.description}</span></div>}
                                    />
                                    <div className='ps-4 ms-4 mt-2'>
                                        {isActive &&
                                            <>
                                                <Steps
                                                    className='w-100'
                                                    style={{ marginTop: 8, width: '100%' }}
                                                    current={currentProcess}
                                                    status={undefined}
                                                    // items={group.items.map((item, idx) => ({
                                                    //     ...item,
                                                    //     status: idx < currentProcess ? "finish" : idx === currentProcess ? "process" : "wait"
                                                    // }))}
                                                    items={renderSteps(group.items, currentProcess)}
                                                />
                                                {group.items.length > 3 &&
                                                    <div className={'text-end mt-2'}>
                                                        <div className={'btn btn-light-secondary py-2 text-end text-dark  px-7'}>
                                                            <div className="d-flex justify-content-around align-items-center w-30"
                                                                onClick={() => { setExpanded(!expanded); }}>
                                                                <Icon name={expanded ? 'play_circle' : 'expand_circle_up'} className={'fs-5'} />
                                                                <span className="ms-1 fs-8">{expanded ? 'Hide' : 'Show all'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </List.Item>
                        </div>
                    )
                }}
            />
        </div>
    );
}